import React, {
	memo,
	useCallback,
	useEffect,
	useRef,
	forwardRef,
	useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
import "./styles/scss/SearchBox.scss";

const App = forwardRef(function App({ placeholder, callback }, parentRef) {
	const navigate = useNavigate();
	const ref = useRef(null);

	useImperativeHandle(
		parentRef,
		() => {
			return {
				setValue(value) {
					ref.current.value = value;
				},
			};
		},
		[]
	);

	const toSearch = useCallback(() => {
		const value = ref.current.value;
		if (callback) {
			callback(value);
		} else {
			if (!value.trim()) return;

			navigate(`/Search/${value}`);
		}
	}, [callback, navigate]);

	useEffect(() => {
		const cb = (e) => {
			if (e.keyCode === 13) {
				toSearch();
			}
		};

		document.addEventListener("keydown", cb, false);

		return () => {
			document.removeEventListener("keydown", cb, false);
		};
	}, [toSearch]);

	return (
		<div className="search-box">
			<input ref={ref} type="text" placeholder={placeholder} />
			<div onClick={toSearch}></div>
		</div>
	);
});

export default memo(App);
